export const OPEN_POPUP = "OPEN_POPUP";
export const CLOSE_POPUP = "CLOSE_POPUP";

const initialState = {
  open: false,
  type: "",
  code: "",
  onSubmit: () => {},
};

export const ModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_POPUP:
      return {
        ...state,
        open: true,
        type: action.payload.type,
        description: action.payload.description,
        onSubmit: action.payload.onSubmit,
      };
    case CLOSE_POPUP:
      return {
        ...state,
        open: false,
        type: "",
        code: "",
        onSubmit: () => {},
      };
    default:
      return state;
  }
};
